import React, { useState, useEffect, useRef } from "react";
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import HeaderAnim from '../common/utils/animations/textRevealAnimation';
import InView from "react-intersection-observer";
export default function HomeIntroColumn(props) {
  const { title, header, content } = props.data;
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <InView as="div" onChange={(inView) => setIsVisible(inView)} className="intro-content-section section-gap-small" threshold={[0.05, 0.1, 0.15, 0.2]}>
        <div className="container">
          <div className="row d-flex flex-wrap">
            <div
              className="col intro-leftbar">
              <h3 className="theme-color-title">{isVisible ? < HeaderAnim header={title} /> : <span>{title.substring(0, 1)}</span>}</h3>
              <h4 className="h3">{header}</h4>
            </div>
            <div
              className="col intro-rightbar">
              <p>{content}</p>
            </div>
          </div>
        </div>
      </InView>
    </>
  );
}
